export default {
  CALL_ALREADY_IN_PROGRESS: 'CALL_ALREADY_IN_PROGRESS',
  NETWORK_ERROR: 'NETWORK_ERROR',
}
